module.exports = __webpack_public_path__ + "img/4.428aedb4.png";